import React from 'react';
import { Globe } from 'lucide-react';
import { fromCvInput, localConversion } from '@/utils/prospectTime';

// Valor no formato datetime-local, sempre interpretado como hora de Cabo Verde (UTC-1).
export const CvDateTimeInput = ({ value, onChange, testid, className = '', ...rest }) => {
  const conv = value ? localConversion(fromCvInput(value)) : null;
  return (
    <div className="flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <input type="datetime-local" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
          className={`flex-1 min-w-[190px] h-10 rounded-md border border-gray-300 bg-white px-3 text-sm ${className}`} {...rest} />
        <span className="whitespace-nowrap rounded bg-blue-50 px-2 py-1 text-[11px] font-semibold text-blue-800" data-testid={`${testid}-tz`}>Hora de Cabo Verde</span>
      </div>
      {conv && <p className="mt-1 flex items-center gap-1 text-[11px] text-amber-700" data-testid={`${testid}-local`}><Globe className="h-3 w-3" />{conv}</p>}
    </div>
  );
};
